import SearchApiResponseBase from '../../../../../Base/Domain/SearchApiResponseBase';
import UserSummaryListItemModel from '..//UserSummaryListItemModel';

class UserSearchSummaryResponseModel extends SearchApiResponseBase {

  constructor(params) {

    super(params, UserSummaryListItemModel);

    if (typeof params === 'undefined' || params === null) {
      return;
    }

  }

}

export default UserSearchSummaryResponseModel;